import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from 'vuex-persistedstate';
import moment from 'moment';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    logs: {},
    notes: {},
    moodLog: [],
    dateFilter: null,
    dark: false,
    displayTags: true,
    displayRatings: true,
    sparklineMode: 'trend',
    fillSparklines: false,
    alwaysDisplayTaskTools: false,
    displayTimers: true,
    displayUpcomingBox: true,
    useGeolocation: false,
    displayGeolocation: false,
    displayNotes: true,
    theme: null,
    togglIntegrationActive: false,
    togglApiKey: null,
    togglWorkspaceId: null
  },
  mutations: {
    SET_LOGS(state, payload) {
      state.logs = { ...payload };
    },
    SET_NOTES(state, payload) {
      state.notes = { ...payload };
    },
    SET_NOTE(state, payload) {
      Vue.set(state.notes, payload.date, payload.notes);
    },
    SET_THEME(state, payload) {
      state.theme = payload;
    },
    CLEAR_NOTES(state, payload) {
      state.notes = {};
    },
    CREATE_NOTE_KEY(state, payload) {
      Vue.set(state.notes, payload, '');
    },
    ADD_NOTE_KEY(state, payload) {
      Vue.set(state.notes, payload.date, '');
    },
    SET_MOOD_LOG(state, payload) {
      state.moodLog = [ ...payload ];
    },
    ADD_MOOD(state, payload) {
      state.moodLog.push(payload);
    },
    ADD_LOG_ENTRY(state, payload) {
      if (state.dateFilter) {
        if (!state.logs.hasOwnProperty(payload.date)) {
          Vue.set(state.logs, payload.date, []);
        }
        if (payload.date !== null && state.logs.hasOwnProperty(payload.date)) {
          state.logs[payload.date].push(payload.item);
        }
      }
    },
    REMOVE_LOG_ENTRIES(state, payload) {
      for (let i = 0; i < payload.remove.length; i++) {
        let id = payload.remove[i];
        let index = state.logs[payload.date].findIndex(item => item.id === id);
        if (index > -1) {
          state.logs[payload.date].splice(index, 1);
        } else {
          console.warn("index not found", id);
        }
      }
    },
    SET_DATE_FILTER(state, payload) {
      state.dateFilter = payload;
    },
    RESET_DATE_FILTER(state) {
      state.dateFilter = null
    },
    ADD_DATE_KEY(state, payload) {
      if (payload !== null && !state.logs.hasOwnProperty(payload)) Vue.set(state.logs, payload, []);
    },
    SET_ITEM_TAGS(state, payload) {
      Vue.set(state.logs[payload.item.date][payload.index], 'tags', payload.item.tags);
    },
    SET_ITEM_RATING(state, payload) {
      Vue.set(state.logs[payload.item.date][payload.index], 'rating', payload.item.rating);
    },
    ADD_ITEM_TIMER(state, payload) {
      state.logs[payload.date][payload.index].timers.push(payload.timer);
    },
    SET_ITEM_START_TIME(state, payload) {
      Vue.set(state.logs[payload.date][payload.index], 'startTime', payload.startTime);
    },
    SET_DARK_MODE(state, payload) {
      state.dark = payload;
    },
    SET_DISPLAY_NOTES(state, payload) {
      state.displayNotes = payload;
    },
    SET_DISPLAY_TAGS(state, payload) {
      state.displayTags = payload;
    },
    SET_DISPLAY_UPCOMING_BOX(state, payload) {
      state.displayUpcomingBox = payload;
    },
    SET_DISPLAY_RATINGS(state, payload) {
      state.displayRatings = payload;
    },
    SET_USE_GEOLOCATION(state, payload) {
      state.useGeolocation = payload;
    },
    SET_DISPLAY_GEOLOCATION(state, payload) {
      state.displayGeolocation = payload;
    },
    SET_DISPLAY_TIMERS(state, payload) {
      state.displayTimers = payload;
    },
    SET_SPARKLINE_MODE(state, payload) {
      state.sparklineMode = payload;
    },
    SET_FILL_SPARKLINE(state, payload) {
      state.fillSparklines = payload;
    },
    SET_ALWAYS_DISPLAY_TASK_TOOLS(state, payload) {
      state.alwaysDisplayTaskTools = payload;
    },
    SET_ITEM_PROP(state, payload) {
      if (payload.prop) {
        if (state.logs.hasOwnProperty(payload.date)) {
          if (state.logs[payload.date][payload.index]) {
            if (state.logs[payload.date][payload.index].hasOwnProperty(payload.prop)) {
              Vue.set(state.logs[payload.date][payload.index], payload.prop, payload.value);
            }
          }
        }
      }
    },
    CREATE_ITEM_PROP(state, payload) {
      if (payload.prop) {
        if (state.logs.hasOwnProperty(payload.date)) {
          if (state.logs[payload.date][payload.index]) {
            if (!state.logs[payload.date][payload.index].hasOwnProperty(payload.prop)) {
              Vue.set(state.logs[payload.date][payload.index], payload.prop, payload.value);
            }
          }
        }
      }
    },
    MOVE_LOG_ENTRY(state, payload) {
      if (state.logs.hasOwnProperty(payload.date)) {
        if (state.logs[payload.date][payload.index]) {
          Vue.set(state.logs[payload.date][payload.index], 'id', payload.id);
          Vue.set(state.logs[payload.date][payload.index], 'parent_id', payload.parent_id);
        }
      }
    },
    SET_TOGGL_INTEGRATION_ACTIVE(state, payload) {
      state.togglIntegrationActive = payload;
    },
    SET_TOGGL_API_KEY(state, payload) {
      state.togglApiKey = payload;
    },
    SET_TOGGL_WORKSPACE_ID(state, payload) {
      state.togglWorkspaceId = payload;
    }
  },
  actions: {
    addLogEntry({ commit, state, getters }, data) {

      let parentId = data.parentId;
      let siblings = state.logs[data.date].filter(s => s.parent_id === parentId);
      let cur = -1;
      let id = null;

      if (siblings) {
        do {
          cur++;
          id = parentId + "." + cur;
        } while (siblings.findIndex(c => c.id === id) > -1);
      } else {
        id = "0.0";
      }

      let item = {
        id: id,
        date: data.date,
        name: '',
        parent_id: parentId,
        rating: 0,
        tags: [],
        comments: [],
        notes: '',
        startTime: null,
        timers: [],
        location: data.location
      };
      let payload = {
        date: data.date,
        item: item
      };
      commit('ADD_LOG_ENTRY', payload);

      return id;
    },
    setItemName({ commit, state }, item) {
      let index = state.logs[item.date].findIndex(el => el.id === item.id);
      let payload = {
        date: item.date,
        index: index,
        prop: 'name',
        value: item.name
      };
      commit('SET_ITEM_PROP', payload);
    },
    setLogs({ commit }, logs) {
      commit('SET_LOGS', logs);
    },
    setMoodlog({ commit }, moods) {
      commit('SET_MOOD_LOG', moods);
    },
    setNotes({ commit }, notes) {
      commit('SET_NOTES', notes);
    },
    setTheme({ commit }, theme) {
      commit('SET_THEME', theme);
    },
    addMood({ commit, state }, mood) {
      let today = new Date().toISOString().slice(0, 10);
      commit('ADD_MOOD', mood);
    },
    saveNote({ commit, state }, payload) {
      if (!state.notes.hasOwnProperty(payload.date)) {
        commit('CREATE_NOTE_KEY', payload.date);
      }
      commit('SET_NOTE', payload);
    },
    addItemTimer({ commit, state }, timer) {
      let index = state.logs[timer.item.date].findIndex(el => el.id === timer.item.id);
      let payload = {
        date: timer.item.date,
        index: index, 
        timer: timer.timer
      };
      commit('ADD_ITEM_TIMER', payload);
    },
    setItemStartTime({ commit, state }, item) {
      let index = state.logs[item.date].findIndex(el => el.id === item.id);
      let payload = {
        date: item.date,
        index: index, 
        startTime: item.startTime
      };
      commit('SET_ITEM_START_TIME', payload);
    },
    clearItemStartTime({ commit, state }, item) {
      let index = state.logs[item.date].findIndex(el => el.id === item.id);
      let payload = {
        date: item.date,
        index: index,
        prop: 'startTime',
        value: null
      };
      commit('SET_ITEM_PROP', payload);
    },
    removeLogEntry({ state, commit, getters }, entry) {
      let remove = [ entry.id ];
      let collect = (children) => children.forEach((c) => { remove.push(c.id); collect(c.children); });
      collect(entry.children);
      let payload = {
        date: getters.dateFilter,
        remove: remove
      };
      commit('REMOVE_LOG_ENTRIES', payload);
    },
    setItemNotes({ commit, state }, data) {
      let index = state.logs[data.date].findIndex(el => el.id === data.id);
      if (!state.logs[data.date][index].hasOwnProperty('notes')) {
        commit('CREATE_ITEM_PROP', {
          date: data.date,
          index: index,
          prop: 'notes',
          value: ''
        });
      }
      let payload = {
        date: data.date,
        index: index,
        prop: 'notes',
        value: data.notes
      };
      commit('SET_ITEM_PROP', payload);
    },
    appendItemNotes({ commit, state }, data) {
      let index = state.logs[data.date].findIndex(el => el.id === data.id);
      if (!state.logs[data.date][index].hasOwnProperty('notes')) {
        commit('CREATE_ITEM_PROP', {
          date: data.date,
          index: index,
          prop: 'notes',
          value: ''
        });
      }
      let notes = state.logs[data.date][index].notes;
      if (notes.trim() != '') notes += '\n';
      notes += data.notes;
      let payload = {
        date: data.date,
        index: index,
        prop: 'notes',
        value: notes
      };
      commit('SET_ITEM_PROP', payload);
    },
    setDateFilter({ state, commit }, value) {
      if (!state.logs.hasOwnProperty(value)) commit('ADD_DATE_KEY', value);
      commit('SET_DATE_FILTER', value);
    },
    resetDateFilter({ commit }) {
      commit('RESET_DATE_FILTER');
    },
    setDarkMode({ commit }, value) {
      commit('SET_DARK_MODE', value);
    },
    clearNotes({ commit }) {
      commit('CLEAR_NOTES');
    },
    setDisplayNotes({ commit }, value) {
      commit('SET_DISPLAY_NOTES', value);
    },
    setSparklineMode({ commit }, value) {
      commit('SET_SPARKLINE_MODE', value);
    },
    setFillSparklines({ commit }, value) {
      commit('SET_FILL_SPARKLINE', value);
    },
    setDisplayTags({ commit }, value) {
      value = value || false;
      commit('SET_DISPLAY_TAGS', value);
    },
    setDisplayUpcomingBox({ commit }, value) {
      value = value || false;
      commit('SET_DISPLAY_UPCOMING_BOX', value);
    },
    setUseGeolocation({ commit }, value) {
      commit('SET_USE_GEOLOCATION', value);
    },
    setDisplayGeolocation({ commit }, value) {
      commit('SET_DISPLAY_GEOLOCATION', value);
    },
    setDisplayRatings({ commit }, value) {
      commit('SET_DISPLAY_RATINGS', value);
    },
    setDisplayTimers({ commit }, value) {
      commit('SET_DISPLAY_TIMERS', value);
    },
    setItemTags({ state, commit }, item) {
      if (state.logs.hasOwnProperty(item.date)) {
        let index = state.logs[item.date].findIndex(el => el.id == item.id);
        commit('SET_ITEM_TAGS', { item: item, index: index });
      }
    },
    setItemRating({ state, commit }, item) {
      if (state.logs.hasOwnProperty(item.date)) {
        let index = state.logs[item.date].findIndex(el => el.id == item.id);
        commit('SET_ITEM_RATING', { item: item, index: index });
      }
    },
    setAlwaysDisplayTaskTools({ commit }, value) {
      commit('SET_ALWAYS_DISPLAY_TASK_TOOLS', value);
    },
    moveItem({ commit, state }, item) {

      let list = state.logs[item.date];
      let cur = -1;
      let id = null;
      do {
        cur++;
        id = item.parent_id + "." + cur;
      } while (list.findIndex(c => c.id === id) !== -1);
      item.new_id = id;

      let move = (item) => {

        let iid = (item.new_id) ? item.new_id.split('.').pop() : item.id.split('.').pop();
        let newId = item.parent_id + '.' + iid;

        let index = state.logs[item.date].findIndex(el => el.id === item.id);
        let payload = {
          date: item.date,
          id: newId,
          parent_id: item.parent_id,
          index: index
        };
        commit('MOVE_LOG_ENTRY', payload);

        if (item.children.length > 0) {
          item.children.forEach(child => {
            child.parent_id = newId;
            move(child);
          });
        }
      }

      move(item);
    },
    setTogglApiKey({ commit }, key) {
      commit('SET_TOGGL_API_KEY', key);
    },
    setTogglWorkspaceId({ commit }, id) {
      commit('SET_TOGGL_WORKSPACE_ID', id);
    },
    setTogglIntegrationActive({ commit }, active) {
      commit('SET_TOGGL_INTEGRATION_ACTIVE', active);
    }
  },
  getters: {
    today() {
      return new Date().toISOString().slice(0, 10);
    },
    moodLog(state) {
      return state.moodLog;
    },
    lastMood(state) {
      return state.moodLog[state.moodLog.length - 1];
    },
    nestedLogs(state) {
      let func = function(list) {

        let map = {};
        let roots = [];

        for (let i = 0; i < list.length; i++) {
          map[list[i].id] = i; // initialize the map
          list[i].children = []; // initialize the children
        }
        for (let i = 0; i < list.length; i++) {
          let node = list[i];
          if (node.parent_id !== "0") {
            // if you have dangling branches check that map[node.parentId] exists
            if (list[map[node.parent_id]]) {
              list[map[node.parent_id]].children.push(node);
            } else {
              console.warn("missing item", node.parent_id);
            }
          } else {
            roots.push(node);
          }
        }
        return roots;
      }

      let filtered = (state.dateFilter && state.logs.hasOwnProperty(state.dateFilter)) ? JSON.parse(JSON.stringify(state.logs[state.dateFilter])) : []
      let result = [];
      if (filtered.length > 0) {
        result = func(filtered);
      }
      return result;
    },
    filteredLog(state) {
      return (state.dateFilter) ? state.logs[state.dateFilter] : []
    },
    logs(state) {
      return state.logs;
    },
    dark(state) {
      return state.dark;
    },
    displayNotes(state) {
      return state.displayNotes;
    },
    displayTags(state) {
      return state.displayTags;
    },
    useGeolocation(state) {
      return state.useGeolocation;
    },
    displayGeolocation(state) {
      return state.displayGeolocation;
    },
    displayRatings(state) {
      return state.displayRatings;
    },
    displayUpcomingBox(state) {
      return state.displayUpcomingBox;
    },
    displayTimers(state) {
      return state.displayTimers;
    },
    sparklineMode(state) {
      return state.sparklineMode;
    },
    fillSparklines(state) {
      return state.fillSparklines;
    },
    logRatings(state) {
      let result = {};
      for (let date in state.logs) {
        let sum = 0;
        let avg = 0;
        let ratingCount = state.logs[date].filter(el => el.rating > 0).length;
        state.logs[date].forEach(el => sum += el.rating);
        if (state.logs[date].length > 0) {
          avg = sum / ratingCount;
        } else {
          avg = sum;
        }
        let moods = state.moodLog.filter(item => item.timestamp.slice(0, 10) == date).map(item => item.value);
        let moodAverage = 0;
        if (moods.length > 0) {
          moods.forEach(item => { moodAverage += item; });
          moodAverage = (moodAverage / moods.length).toFixed(2);
        }
        result[date] = {};
        result[date].rating = avg;
        result[date].mood = moods;
        result[date].moodAverage = moodAverage;
      }

      return result;
    },
    logTimers(state) {
      let result = {};
      for(let date in state.logs) {
        let total = 0;
        state.logs[date].forEach(item => {
          if (item.hasOwnProperty('timers')) {
            if (item.timers.length > 0) {
              item.timers.forEach(timer => total += ((timer.end - timer.start) / 1000));
            }
          }
        });
        result[date] = total;
      }
      return result;
    },
    dateFilter(state) {
      return state.dateFilter;
    },
    alwaysDisplayTaskTools(state) {
      return state.alwaysDisplayTaskTools;
    },
    autoCompleteTasks(state) {
      let result = new Set();
      for (let date in state.logs) {
        state.logs[date].map(item => {
          if (item && item.name) {
            result.add(item.name);
          }
        });
      }

      return Array.from(result);
    },
    activeTimers(state) {
      let timers = [];
      for (let date in state.logs) {
        let items = state.logs[date].filter(item => item.startTime);
        timers = timers.concat(items);
      }
      return timers;
    },
    upcomingTasks(state) {
      let tasks = null;
      let now = moment.utc();
      for (let d in state.logs) {
        if (moment.utc(d).isAfter(now)) {
          if (state.logs[d].length > 0) {
            if (!tasks) tasks = {};
            tasks[d] = state.logs[d].filter(item => item.parent_id == '0');
          }
        }
      }
      return tasks;
    },
    theme(state) {
      return state.theme;
    },
    notes(state) {
      return state.notes;
    },
    todaysNotes(state) {
      return (state.notes.hasOwnProperty(state.dateFilter)) ? state.notes[state.dateFilter] : '';
    },
    togglApiKey(state) {
      return state.togglApiKey;
    },
    togglWorkspaceId(state) {
      return state.togglWorkspaceId;
    },
    togglIntegrationActive(state) {
      return state.togglIntegrationActive;
    }
  },
  plugins: [createPersistedState()]
});
